import { DataGrid } from "devextreme-react";
import { Column, HeaderFilter, Scrolling } from "devextreme-react/data-grid";
import React, { memo, useEffect, useState } from "react";
import Modal from "react-modal";
import { axiosGet } from "../../apis/useAxios";
import { DateFormat } from "../../helpers/fixcodes";
import moment from "moment";

export default function UserActivityHistoryComponent(props) {
  const [state, setState] = useState({
    activityLogDataGrid: [],
    openViewModal: {
      openModal: false,
      description: "",
      userName: "",
      createdTime: "",
    },
  });
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchGridDataOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);
  const fetchGridDataOnPageLoad = async () => {
    try {
      const response = await axiosGet("/UserActivityLog/list", {
        airlineCode: props?.airlineCode ?? "",
        columnValue1: props?.columnValue1 ?? "",
        columnValue2: props?.columnValue2 ?? "",
      });
      setState((prev) => ({
        ...prev,
        activityLogDataGrid: response?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "55%" } }}
        onAfterClose={() => {
          setState((prev) => ({
            ...prev,
            activityLogDataGrid: [],
          }));
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            [ {props?.displayTitle ?? props.columnValue1} ] Changes History
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <DataGrid
              dataSource={state.activityLogDataGrid}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={true}
              showRowLines={true}
              showColumnLines={true}
            >
              <Column
                dataField="id"
                caption=""
                allowSorting={false}
                allowSearch={false}
                allowExporting={false}
                allowFiltering={false}
                fixed={true}
                width={"auto"}
                cellRender={(data) => {
                  return (
                    <a
                      href="#"
                      title="Udpate"
                      onClick={(e) => {
                        e.preventDefault();
                        setState((prev) => ({
                          ...prev,
                          openViewModal: {
                            openModal: true,
                            description: data.data.description,
                            userName: data.data.userName,
                            createdTime: data.data.createdTime,
                          },
                        }));
                      }}
                      className="btn-link"
                    >
                      <i style={{ cursor: "pointer" }} className="fas fa-eye" />
                    </a>
                  );
                }}
              />
              <Column
                dataField="description"
                caption="Description"
                allowSearch={true}
                width={"60%"}
              />
              <Column
                dataField="userName"
                caption="Created By"
                allowSearch={true}
              />
              <Column
                dataField="createdTime"
                caption="Date"
                allowSearch={true}
                dataType={"datetime"}
                format={DateFormat.DisplayDateTime24NorthFormat}
              />
              <Scrolling mode="standard" showScrollbar="always" />
              <HeaderFilter visible={true} />
            </DataGrid>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Cancel"
            className="btn btn-secondary btn-sm "
            onClick={() => {
              props.onClose();
            }}
          >
            <i className="fas fa-times" />
            &nbsp;Close
          </button>
        </div>
      </Modal>
      {state.openViewModal.openModal && (
        <ViewHistoryComponent
          displayTitle={props?.displayTitle ?? props?.columnValue1 ?? ""}
          description={state.openViewModal.description}
          userName={state.openViewModal.userName}
          createdTime={state.openViewModal.createdTime}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openViewModal: {
                openModal: false,
                description: "",
                userName: "",
                createdTime: "",
              },
            }));
          }}
        />
      )}
    </>
  );
}

const ViewHistoryComponent = memo((props) => {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "45%" } }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            [ {props?.displayTitle ?? ""} ] Changes History
          </h6>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group">
                <label>Description</label>
                <textarea
                  style={{ height: "100%" }}
                  className="form-control form-control-sm"
                  rows={6}
                  readOnly={true}
                  disabled={true}
                  value={props.description ?? ""}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="form-group">
                <label>User Name</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  readOnly={true}
                  disabled={true}
                  value={props.userName}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="form-group">
                <label>Date</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  readOnly={true}
                  disabled={true}
                  value={
                    props.createdTime
                      ? moment(props.createdTime).format(
                          DateFormat.MomentDisplayDateTimeAMPMFullFormat,
                        )
                      : ""
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              props.onClose();
            }}
            title="Close"
          >
            <i className="fas fa-times" />
            &nbsp;Close
          </button>
        </div>
      </Modal>
    </>
  );
});
